import { jsonpRequest } from '../../utils/jsonp';

const API_KEY = process.env.REACT_APP_VWORLD_API_KEY || '';

// https://www.vworld.kr/dev/v4dv_geocoderguide2_s001.do
export interface AddressLevels {
  level0: string; // 국가
  level1: string; // 시도
  level2: string; // 시군구
  level3: string; // (일반구)구
  level4: string; // (도로)도로명, (지번)법정읍, 면, 동 명
  level4A: string; //(도로)행정읍·면·동 명, (지번)지원안함
  level4AC: string; // (도로)행정읍·면·동 코드, (지번)지원안함
  level4L: string; // (도로)길, (지번)번지
  level5: string; // 상세주소
}

/**
 * VWorld Geocoder API를 호출하여 정제된 주소 정보를 가져옵니다.
 * @param {string} fullAddress - 검색할 전체 주소 문자열.
 * @returns {Promise<AddressLevels | null>}
 */
export const getAddressLevelsFromVWorld = async (fullAddress: string): Promise<AddressLevels | null> => {
  if (!fullAddress) {
    return null;
  }

  // Geocoder API 요청에 필요한 파라미터 구성
  const params = {
    service: 'address',
    request: 'getcoord',
    version: '2.0',
    crs: 'EPSG:4326',
    address: fullAddress,
    refine: 'true', // 정제된 주소 구조를 받기 위해 true로 설정
    simple: 'false',
    format: 'json',
    type: 'PARCEL', // 지번 주소 우선 검색
    key: API_KEY,
  };

  try {
    // jsonpRequest 헬퍼를 사용하여 API 호출
    const data = await jsonpRequest('https://api.vworld.kr/req/address', params);

    if (data?.response?.status === 'OK') {
      const addressStructure = data.response.refined.structure as AddressLevels;
      return addressStructure;
    }

    return null;
  } catch (error) {
    console.error('주소 정보를 가져오는 중 오류가 발생했습니다:', error);
    return null;
  }
};
